<script setup lang="ts">
import SmsChatDetailsDescList from '@/components/descLists/SmsChatDetailsDescList.vue';
import * as commonConstants from '@/constants/common';

export interface Props {
  name?: string;
  role?: string;
  phone?: string;
  email?: string;
  state?: string;
  driverCode?: number;
}
export type SmsChatDetailsSectionProps = Props;

const props = withDefaults(defineProps<Props>(), {
  name: commonConstants.EM_DASH,
  role: commonConstants.EM_DASH,
  phone: undefined,
  email: undefined,
  state: undefined,
  driverCode: undefined,
});
</script>

<template>
  <section
    :class="$style.smsChatDetailsSection"
    data-testid="smsChatDetailsSection"
  >
    <div :class="$style.nameAndRole">
      <div :class="$style.name">{{ props.name }}</div>
      <div :class="$style.role">{{ props.role }}</div>
    </div>
    <SmsChatDetailsDescList
      :phone="props.phone"
      :email="props.email"
      :state="props.state"
      :driverCode="props.driverCode"
    />
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatDetailsSection {
  border-radius: 4px;
  border: 1px solid colors.$color-brand-50;
  box-shadow: 0px 0px 10px 2px colors.$color-shadow-slate-08;
  padding: 24px;
  display: inline-block;
  min-width: 280px;
}
  .nameAndRole {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
  }
    .name {
      font-size: 18px;
    }
    .role {
      color: colors.$color-text-primary;
      background-color: colors.$color-gray-100;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;
      padding: 4px 8px;
    }
</style>
